import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';
import {
  NotificationsProvider,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { PageContent } from 'app/ui';

import { AddProfile } from '../features';

export const AddProfilePage = observer(() => {
  const notify = useNotifyFactory();

  return (
    <NotificationsProvider value={notify}>
      <AppPage perm="PERM_TERMINAL_PROFILE_CREATE">
        <PageContent>
          <AddProfile />
        </PageContent>
      </AppPage>
    </NotificationsProvider>
  );
});
